import React, { useContext, useEffect, useState, useRef, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import PreviousImages from '../PreviousImages'
import { Cart, OrderPackage, StudentImage } from '../../../models'
import { CustomerContext } from '../../../contexts/CustomerContext'
import PreviewImage from '../../PreviewImage'
import styles from './DownloadImage.module.sass'
import BackgroundPicker from './BackgroundPicker'
import Button from '../../Button'
import Spinner from '../../Spinner'
import Order from "../../../models/Order";
import Typography from "../../Typography";
import useImageOrientations from "../../../hooks/useImageOrientations";
import {IMAGE_ORIENTATION_CACHE} from "../../../utils/variables";

const getItemKey = (image) => {
  const isPose = image.resourceIdentifier?.type === 'poses'
  return `${isPose ? 'pose' : 'student_image'}-${image.id}`
}

const buildItemsFromImages = (images) => {
  return images.map((image) => {
    const isPose = image.resourceIdentifier?.type === 'poses'
    return { type: isPose ? 'pose' : 'student_image', id: image.id }
  })
}

const DownloadImage = () => {
  const { customer, setCustomer } = useContext(CustomerContext)
  const { orderId, email } = useParams()
  const [studentImage, setStudentImage] = useState()
  const [background, setBackground] = useState()
  const [orderPackages, setOrderPackages] = useState([])
  const [orderPackage, setOrderPackage] = useState()
  const [backgrounds, setBackgrounds] = useState([])
  const [initialBackgrounds, setInitialBackgrounds] = useState([])
  const [initialBackground, setInitialBackground] = useState([])
  const [images, setImages] = useState([])
  const [index, setIndex] = useState(0)
  const [hasLoadedOrder, setHasLoadedOrder] = useState(false)
  const [availability, setAvailability] = useState({})
  const [isCheckingAvailability, setIsCheckingAvailability] = useState(true)
  const pollingRef = useRef(null)
  localStorage.setItem('isUsingAccessCode', true);

  const imageData = useImageOrientations(images.map((im) => im.imageUrl));
  const bgData = useImageOrientations(backgrounds.map((bg) => bg.imageUrl));

  const checkAvailability = useCallback((items) => {
    fetch('/download/check_image_availability', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_id: orderId, email, items }),
    })
      .then((res) => res.json())
      .then((data) => {
        setAvailability(data.availability || {})
        setIsCheckingAvailability(false)

        const allReady = Object.values(data.availability || {}).every((v) => v === true)
        if (allReady && pollingRef.current) {
          clearInterval(pollingRef.current)
          pollingRef.current = null
        }
      })
      .catch(() => {
        setIsCheckingAvailability(false)
      })
  }, [orderId, email])

  useEffect(() => {
    if (images.length === 0) return

    const items = buildItemsFromImages(images)
    checkAvailability(items)

    pollingRef.current = setInterval(() => {
      checkAvailability(items)
    }, 30000)

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current)
        pollingRef.current = null
      }
    }
  }, [images, checkAvailability])

  useEffect(() => {
    if (!studentImage) return;

    const orientation = IMAGE_ORIENTATION_CACHE[studentImage.imageUrl]?.orientation || 'PORTRAIT';

    const bgsForImage = initialBackgrounds
      .filter((bg) => IMAGE_ORIENTATION_CACHE[bg.imageUrl]?.orientation === orientation);

    setBackground(bgsForImage[0]);

  }, [studentImage, JSON.stringify(imageData), imageData.length, JSON.stringify(bgData), bgData.length, JSON.stringify(IMAGE_ORIENTATION_CACHE)]);

  useEffect(() => {
    if (customer.currentStudent) return;
    if (!orderPackage) return;

    setCustomer({ ...customer, currentStudent: orderPackage.student })
  }, [orderPackage])

  useEffect(() => {
    console.log("studentImage changed")
    showFirst()
  }, [studentImage])
  useEffect(() => {
    console.log("backgrounds changed")
    console.log(backgrounds)
    showFirst()
  }, [backgrounds])
  useEffect(() => {
    console.log("orderPackage changed")
    showFirst()
  }, [orderPackage])

  const goBack = () => {
    if (index === 0) return

    setBackground(backgrounds[index - 1])
    setInitialBackground(initialBackgrounds[index - 1])
    setStudentImage(images[index - 1])
    setOrderPackage(orderPackages[index - 1])
    setIndex((prev) => prev - 1)
  }

  const goForward = () => {
    if (index === images.length - 1) return

    setBackground(backgrounds[index + 1])
    setInitialBackground(initialBackgrounds[index + 1])
    setStudentImage(images[index + 1])
    setOrderPackage(orderPackages[index + 1] || orderPackages[0])
    setIndex((prev) => prev + 1)
  }

  const showFirst = () => {
    //to fix downloadbutton not haveing correct url before forward pressed
    console.log(index)
    if (backgrounds)
    {
      console.log(backgrounds[0])
    }

    if (index == 0 && backgrounds  )
    {
      console.log("showFirst")
      setBackground(backgrounds[0])
    }

  }

  useEffect(() => {
    if (!customer.currentStudent) return

    const cartScope = Cart.where({ purchased: true, for_student: customer.currentStudent.id }).order('createdAt')

    OrderPackage
      .includes(['cart', 'background'])
      .merge({ carts: cartScope })
      .where({ studentId: customer.currentStudent.id })
      .all()
      .then((res) => {
        const carts = res.data.filter((orderPackage) => orderPackage.cart).map((orderPackage) => orderPackage.cart)

        const lastCart = carts[carts.length - 1]
        if (customer && customer.cart) return

        const newCart = new Cart({
          email: lastCart.email, schoolId: customer.currentStudent.schoolId,
        })

        newCart.save().then(() => setCustomer({ ...customer, cart: newCart }))
      })
  }, [customer, customer && customer.currentStudent && customer.currentStudent.id])

  useEffect(() => {
    console.log('Download button check:', {
      studentImage: !!studentImage,
      backgrounds: !!backgrounds,
      orderPackage: !!orderPackage,
      currentStudentImage: studentImage?.imageUrl,
      currentBackground: background?.imageUrl,
      backgroundsLength: backgrounds?.length
    });
  }, [studentImage, backgrounds, orderPackage, background]);

  useEffect(() => {
  if (!studentImage) return;

  const orientation = IMAGE_ORIENTATION_CACHE[studentImage.imageUrl]?.orientation || 'PORTRAIT';
  console.log('Orientation check:', {
    imageUrl: studentImage.imageUrl,
    detectedOrientation: orientation,
    totalBackgrounds: initialBackgrounds.length,
    matchingBackgrounds: initialBackgrounds.filter((bg) =>
      IMAGE_ORIENTATION_CACHE[bg.imageUrl]?.orientation === orientation
    ).length
  });

  const bgsForImage = initialBackgrounds
    .filter((bg) => IMAGE_ORIENTATION_CACHE[bg.imageUrl]?.orientation === orientation);

  setBackground(bgsForImage[0]);

}, [studentImage, JSON.stringify(imageData), imageData.length, JSON.stringify(bgData), bgData.length, JSON.stringify(IMAGE_ORIENTATION_CACHE)]);

  useEffect(() => {
    Order
      .includes({
        cart: {
          orderPackages: [
            { addonSheets: [{ pose: 'studentImage' }, 'background'] },
            'background',
            'package',
            'student',
            'studentImage',
            { sheets: ['studentImage', 'background', 'foreground', { pose: 'studentImage' }] },
            { api_option: 'image_types' },
            { extras: 'prices' },
          ],
        },
      })
      .where({ for_email: [orderId, email, true] })
      .first()
      .then((response) => {
        if (!response.data) {
          setHasLoadedOrder(true)
          return
        }

        let purchasedImages = [];
        let purchasedBackgrounds = [];
        let purchasedOrderPackages = [];

        response.data && response.data.cart.orderPackages.map((orderPackage) => {
          if (orderPackage.hasDownloadableImages) {
            const sheets = orderPackage.sheets.filter((sheet) => sheet.hasDownloadableImage);
            if (sheets.length > 0) {
              sheets.map((sheet) => {
                if (sheet.pose) {
                  purchasedImages.push({ ...sheet.pose, foregroundId: sheet.foregroundId, foreground: sheet.foreground, isPNG: sheet.pose.isPNG, resourceIdentifier: { type: 'poses' } })
                }

                if (sheet.studentImage) {
                  purchasedImages.push(sheet.studentImage)
                }

                purchasedBackgrounds.push(sheet.background)
                purchasedOrderPackages.push(orderPackage)
              })
            } else if (orderPackage.sheets.length > 0) {
              const sheet = orderPackage.sheets[0]

              if (sheet.pose) {
                purchasedImages.push({ ...sheet.pose, foregroundId: sheet.foregroundId, foreground: sheet.foreground, isPNG: sheet.pose.isPNG, resourceIdentifier: { type: 'poses' } })
              }

              if (sheet.studentImage) {
                purchasedImages.push(sheet.studentImage)
              }

              purchasedBackgrounds.push(sheet.background)
              purchasedOrderPackages.push(orderPackage)
            }

            const downloadableAddonSheets = orderPackage.addonSheets.filter((addonSheet) => addonSheet.hasDownloadableImage);

            if (downloadableAddonSheets.length > 0) purchasedOrderPackages.push(orderPackage);

            downloadableAddonSheets.forEach((addonSheet) => {
              purchasedImages.push(addonSheet.pose);
              if (addonSheet.background) purchasedBackgrounds.push(addonSheet.background);
            });
          }

          if (orderPackage.studentImage && orderPackage.studentImage.imageUrl && orderPackage.hasDownloadableImages) {
            purchasedImages.push(orderPackage.studentImage)
            purchasedBackgrounds.push(orderPackage.background)
            purchasedOrderPackages.push(orderPackage);
          }
        })

        purchasedBackgrounds = purchasedBackgrounds.filter(b => !!b);

        setOrderPackages(purchasedOrderPackages);
        setOrderPackage(purchasedOrderPackages[0]);
        setImages(purchasedImages);
        setBackgrounds(purchasedBackgrounds);
        setInitialBackgrounds(purchasedBackgrounds);
        setInitialBackground(purchasedBackgrounds[0]);
        setStudentImage(purchasedImages[0]);
        setBackground(purchasedBackgrounds[0]);
      })
  }, [orderId, email])

  const renderDownloadableImages = () => {
    if (!studentImage) return null;

    return (
      <div className={styles.imageCarousel}>
        {images
          .map((image, i) => {
            return (
              <div
                key={i}
                className={`${styles.imageWrapper} ${i === index ? '' : styles.hidden}`}
              >
                {!initialBackground && (studentImage && studentImage.isPNG()) ? (
                  <BackgroundPicker
                    orderPackage={orderPackage}
                    background={background}
                    setBackground={setBackground}
                    foreground={studentImage}
                    initialBackground={initialBackground}
                  />
                ) : (
                  <div className={styles.previewImageWrapper}>
                    <PreviewImage
                      actualForegroundUrl={image.foregroundId ? image.foreground.imageUrl : undefined}
                      foregroundUrl={image.imageUrl}
                      backgroundUrl={backgrounds[index] ? backgrounds[index].imageUrl : ''}
                      accessCodeOnly={false}
                      noTouchAction
                    />
                  </div>
                )}
              </div>
            )
          })}
        {images.length > 1 && (
          <>
            <button type="button" disabled={index === 0} onClick={goBack}>Previous</button>
            <button type="button" disabled={index === images.length - 1} onClick={goForward}>Next</button>
          </>
        )}
      </div>
    )
  }

  const getHref = () => {
    if(index == 0)
    {
      showFirst
    }
    if (!studentImage) return ''
    if (!background && (studentImage && studentImage.isPNG())) return ''

    const baseUrl = studentImage.isPNG() ? '/download/download_png_image' : '/download/download_image'
    if (studentImage.resourceIdentifier.type === 'poses') {
      return `${baseUrl}/${studentImage.studentImage.studentId}?&background_id=${backgrounds[index] && backgrounds[index].id}&pose_id=${studentImage.id}&order_package_id=${orderPackage.id}&email=${email}${studentImage.foregroundId ? `&foreground_id=${studentImage.foregroundId}` : ''}`
    } else {
      return `${baseUrl}/${studentImage.studentId}?student_image_id=${studentImage.id}${backgrounds[index] && `&background_id=${backgrounds[index].id}`}&order_package_id=${orderPackage.id}&email=${email}`
    }
  }

  const currentImageReady = studentImage ? availability[getItemKey(studentImage)] === true : false
  const readyCount = images.filter((image) => availability[getItemKey(image)] === true).length
  const totalCount = images.length
  const allReady = totalCount > 0 && readyCount === totalCount

  if (!studentImage && hasLoadedOrder) {
    return (
      <Typography align="center" tag="h1" weight="bold">
        No downloadable images have been found for this order. Please try again later or call us for assistance.
      </Typography>
    )
  }

  return (
    <div className={styles.outerPreviewContainer}>
        <div className={styles.previewContainer}>
          <div className={styles.pageContainer}>
              <div className={styles.downloadImgContainer}>
                {totalCount > 0 && (
                  <div className={styles.progressContainer}>
                    {isCheckingAvailability ? (
                      <div className={styles.progressLabel}>Checking image availability...</div>
                    ) : allReady ? (
                      <div className={styles.allReady}>All images ready for download</div>
                    ) : (
                      <>
                        <div className={styles.progressLabel}>{readyCount} of {totalCount} images ready</div>
                        <div className={styles.progressTrack}>
                          <div
                            className={styles.progressFill}
                            style={{ width: `${(readyCount / totalCount) * 100}%` }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                )}

                {isCheckingAvailability && <div style={{ textAlign: 'center', padding: '20px' }}><Spinner /></div>}

                {!isCheckingAvailability && renderDownloadableImages()}

                {!isCheckingAvailability && studentImage && backgrounds && orderPackage && (
                  currentImageReady ? (
                    <a style={{ margin: '12px auto', display: 'block' }} href={getHref()}>
                      <Button fullWidth variant="primary" disabled={images.length === 0}>
                        Download Image
                      </Button>
                    </a>
                  ) : (
                    <div style={{ margin: '12px auto' }}>
                      <Button fullWidth variant="primary" disabled>
                        Preparing Image...
                      </Button>
                    </div>
                  )
                )}
              </div>
              {customer && customer.cart && customer.currentStudent && (
                <div id="previousImagesContainer" className={styles.previousImagesContainer}>
                  <PreviousImages />
                </div>
              )}
        </div>
    </div>
  </div>
  )
}

export default DownloadImage
